import { gql } from '@apollo/client';

export const BUY_CERT = gql`
mutation CreateCert(
    $amount: Int!,
    $customerPhone: String!,
    $customerName: String,
    $customerSurname: String,
    $customerEmail: String,
    $mail: String,
    $name: String!,
    $paymentSystem: String = "A",
) {
    createCert(
        amount: $amount,
        mail: $mail,
        name: $name,
        paymentSystem: $paymentSystem,
        customerData: {
            customerName: $customerName,
            customerEmail: $customerEmail,
            customerSurname: $customerSurname,
            customerPhone: $customerPhone
    }
){
    cert {
        id
        code
        payment{
            status
            alfa{
                payUrl
            }
            yandex{
                payUrl
            }
        }
    }
}}`

